//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Geeft de gegevens van lopende HDN-dossiers die op het scherm getoond moeten worden
     * @param berichtId (optional) 
     * @return Success
     */
    ophalen_van_de_XML_van_een_bericht(vestigingId: string, berichtId: string | null | undefined): Promise<BerichtenXmlOutput> {
        let url_ = this.baseUrl + "/bericht?";
        if (berichtId !== undefined && berichtId !== null)
            url_ += "berichtId=" + encodeURIComponent("" + berichtId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOphalen_van_de_XML_van_een_bericht(_response);
        });
    }

    protected processOphalen_van_de_XML_van_een_bericht(response: Response): Promise<BerichtenXmlOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BerichtenXmlOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BerichtenXmlOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BerichtenXmlOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BerichtenXmlOutput>(null as any);
    }

    /**
     * Geeft de documenten van een HDN-dossier
     * @param vestigingId De identificatie van de vestiging
     * @param dossierId Unieke identificatie van het HDN-dossier
     * @return Success
     */
    ophalen_van_documenten_van_een_HDNDossier(vestigingId: string, dossierId: string): Promise<DocumentenOutput> {
        let url_ = this.baseUrl + "/dossier/{dossierId}/documenten";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOphalen_van_documenten_van_een_HDNDossier(_response);
        });
    }

    protected processOphalen_van_documenten_van_een_HDNDossier(response: Response): Promise<DocumentenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentenOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentenOutput>(null as any);
    }

    /**
     * Download een document van een HDN-dossier
     * @param vestigingId De identificatie van de vestiging
     * @param dossierId Unieke identificatie van het HDN-dossier
     * @param documentId Unieke identificatie van het HDN-document
     * @return Success
     */
    downloaden_van_document_van_een_HDNDossier(vestigingId: string, dossierId: string, documentId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/dossier/{dossierId}/document/{documentId}";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloaden_van_document_van_een_HDNDossier(_response);
        });
    }

    protected processDownloaden_van_document_van_een_HDNDossier(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Geeft de gegevens van lopende HDN-dossiers die op het scherm getoond moeten worden
     * @param vestigingId (optional) 
     * @param limiet (optional) 
     * @return Success
     */
    overzicht_van_lopende_HDN_Dossier_ophalen(vestigingId: string | null | undefined, limiet: number | null | undefined): Promise<DossierSamenvattingOutput> {
        let url_ = this.baseUrl + "/dossier?";
        if (limiet !== undefined && limiet !== null)
            url_ += "limiet=" + encodeURIComponent("" + limiet) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOverzicht_van_lopende_HDN_Dossier_ophalen(_response);
        });
    }

    protected processOverzicht_van_lopende_HDN_Dossier_ophalen(response: Response): Promise<DossierSamenvattingOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DossierSamenvattingOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DossierSamenvattingOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DossierSamenvattingOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DossierSamenvattingOutput>(null as any);
    }

    /**
     * Geeft de gegevens van een HDN-dossier die op het scherm getoond moeten worden
     * @param vestigingId De identificatie van de vestiging
     * @param id id van het HDN Dossier
     * @return Success
     */
    gegevens_van_een_HDN_Dossier_ophalen(vestigingId: string, id: string): Promise<DossierOutput> {
        let url_ = this.baseUrl + "/dossier/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGegevens_van_een_HDN_Dossier_ophalen(_response);
        });
    }

    protected processGegevens_van_een_HDN_Dossier_ophalen(response: Response): Promise<DossierOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DossierOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DossierOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DossierOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DossierOutput>(null as any);
    }

    /**
     * Geeft de gegevens van een HDN-dossier die op het scherm getoond moeten worden
     * @param vestigingId De identificatie van de vestiging
     * @param id id van het HDN Dossier
     * @return No Content
     */
    verwijdert_een_HDN_Dossier(vestigingId: string, id: string): Promise<void> {
        let url_ = this.baseUrl + "/dossier/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVerwijdert_een_HDN_Dossier(_response);
        });
    }

    protected processVerwijdert_een_HDN_Dossier(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Werkt de gegevens van een HDN dossier bij
     * @param vestigingId De identificatie van de vestiging
     * @param id id van het HDN Dossier
     * @param status de gewijzigde status van het HDN Dossier
     * @return No Content
     */
    gegevens_van_een_HDN_Dossier_bijwerken(vestigingId: string, id: string, status: string): Promise<void> {
        let url_ = this.baseUrl + "/dossier/{id}/status/{status}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined.");
        url_ = url_.replace("{status}", encodeURIComponent("" + status));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGegevens_van_een_HDN_Dossier_bijwerken(_response);
        });
    }

    protected processGegevens_van_een_HDN_Dossier_bijwerken(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DossierOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DossierOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DossierOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft de status van alle HDN-dossiers in het adviesdossier.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId Id van het adviesdossier
     * @return Success
     */
    gegevens_van_HDNDossiers_van_een_adviesdossier_ophalen(vestigingId: string, adviesdossierId: string): Promise<DossierSamenvattingOutput> {
        let url_ = this.baseUrl + "/adviesdossier/{adviesdossierId}/status";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGegevens_van_HDNDossiers_van_een_adviesdossier_ophalen(_response);
        });
    }

    protected processGegevens_van_HDNDossiers_van_een_adviesdossier_ophalen(response: Response): Promise<DossierSamenvattingOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DossierSamenvattingOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DossierSamenvattingOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DossierSamenvattingOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DossierSamenvattingOutput>(null as any);
    }

    /**
     * Geeft de laatste versies van alle HDN-dossiers in het adviesdossier.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId Id van het adviesdossier
     * @return Success
     */
    laatste_versies_van_HDNDossiers_van_een_adviesdossier_ophalen(vestigingId: string, adviesdossierId: string): Promise<DossierVersieOutput> {
        let url_ = this.baseUrl + "/adviesdossier/{adviesdossierId}/laatsteversies";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLaatste_versies_van_HDNDossiers_van_een_adviesdossier_ophalen(_response);
        });
    }

    protected processLaatste_versies_van_HDNDossiers_van_een_adviesdossier_ophalen(response: Response): Promise<DossierVersieOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DossierVersieOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DossierVersieOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DossierVersieOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DossierVersieOutput>(null as any);
    }

    /**
     * Geeft aan wanneer de laatste HDN-aanvraag is verzonden voor het gegeven adviesdossier en of deze verwijderd mag worden.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId Id van het adviesdossier
     * @return Success
     */
    laatst_verzonden_aanvraag_van_adviesdossier_ophalen(vestigingId: string, adviesdossierId: string): Promise<LaatstVerzondenAanvraagOutput> {
        let url_ = this.baseUrl + "/adviesdossier/{adviesdossierId}/laatstverzondenaanvraag";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLaatst_verzonden_aanvraag_van_adviesdossier_ophalen(_response);
        });
    }

    protected processLaatst_verzonden_aanvraag_van_adviesdossier_ophalen(response: Response): Promise<LaatstVerzondenAanvraagOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LaatstVerzondenAanvraagOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LaatstVerzondenAanvraagOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LaatstVerzondenAanvraagOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LaatstVerzondenAanvraagOutput>(null as any);
    }

    /**
     * Zoekt een adviesdossier op basis van een zoekopdracht
     * @param vestigingId Het id van de vestiging waar de gebruiker werkt
     * @param body (optional) Criteria en zoektermen waarop gezocht moet worden
     * @return Success
     */
    zoek_HDN_Dossiers(vestigingId: string, body: ZoekHdnDossierInput | null | undefined): Promise<ZoekresultaatDossierOutput> {
        let url_ = this.baseUrl + "/HdnDossiers/Zoeken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processZoek_HDN_Dossiers(_response);
        });
    }

    protected processZoek_HDN_Dossiers(response: Response): Promise<ZoekresultaatDossierOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ZoekresultaatDossierOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ZoekresultaatDossierOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ZoekresultaatDossierOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ZoekresultaatDossierOutput>(null as any);
    }

    /**
     * @return Success
     */
    getVersionInfo(): Promise<VersionInfo> {
        let url_ = this.baseUrl + "/VersionInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVersionInfo(_response);
        });
    }

    protected processGetVersionInfo(response: Response): Promise<VersionInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VersionInfo;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BadRequestResult;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VersionInfo>(null as any);
    }

    /**
     * @return Success
     */
    getFoutcodes(): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/VersionInfo/FoutCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFoutcodes(_response);
        });
    }

    protected processGetFoutcodes(response: Response): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: string; };
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }
}

export interface BadRequestResult {
    statusCode: number;
}

/** Bericht XML output */
export interface BerichtenXmlOutput {
    /** XML van het bericht */
    xml: string | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Documenten overzicht */
export interface DocumentenOutput {
    /** Documenten die aan het dossier gekoppeld zijn. */
    binnengekomenDocumenten: HdnBinnengekomenDocument[] | null;
    /** Documenten die aan het dossier gekoppeld zijn. */
    gevraagdeDocumenten: HdnGevraagdDocument[] | null;
    /** Documenten die aan het dossier gekoppeld zijn. */
    aangeleverdeDocumenten: HdnGevraagdDocument[] | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat de gegevens van een HDN dossier. */
export interface Dossier {
    /** Indicatie dat de aanvraag door een serviceprovider is/wordt afgehandeld. */
    afhandeldDoorServiceprovider: boolean;
    hdnDossierId: string;
    aanvraagVersie: number;
    vestigingId: string;
    adviesdossierId: string;
    adviseur: string | null;
    product: string | null;
    analyseId: string | null;
    dekkingId: string | null;
    ontvangerNaam: string;
    ontvangerNrHdn: string | null;
    verzenderNrHDN: string | null;
    verzenderNaam: string | null;
    status: HdnDossierStatus;
    ontvangerCode: string;
    medewerkerId: string;
    softwareKoppeling: SoftwareKoppelingOptions | null;
    hdnBerichten: HdnBericht[] | null;
    hdnGevraagdeDocumenten: HdnGevraagdDocument[] | null;
    hdnBinnengekomenDocumenten: HdnBinnengekomenDocument[] | null;
    hdnDossierAanvragers: HdnDossierAanvrager[] | null;
}

/** output wrapper voor dossier */
export interface DossierOutput {
    dossier: Dossier | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Gegevens over de status van een HDN-dossier. */
export interface DossierSamenvatting {
    /** Nummer van het dossier */
    hdnDossierId: string;
    /** Identificatie van advies waar dit dossier bij hoort */
    adviesdossierId: string;
    /** Omschrijving van het advies */
    adviesOmschrijving: string | null;
    /** Partij waar bericht naar verstuurd is (ontvangende partij) */
    partijnaam: string | null;
    /** Volledige klantnaam vanuit het adviesdossier */
    klantNaam: string | null;
    /** Adviseur vanuit het adviesdossier */
    adviseur: string | null;
    /** Product vanuit het adviesdossier */
    product: string | null;
    laatstOntvangenBericht: HdnBericht | null;
    status: HdnDossierStatus;
    /** Hoogste versienummer in het HDN-dossier */
    aanvraagVersie: number;
    /** Soort aanvrag, bijv. LX / AX /etc. */
    readonly soortAanvraag: string | null;
    /** Startdatum van het HDN-dossier */
    readonly startDatum: string | null;
    /** Indicatie dat de aanvraag door een serviceprovider is/wordt afgehandeld. */
    afhandeldDoorServiceprovider: boolean;
    softwareKoppeling: SoftwareKoppelingOptions | null;
}

/** Bevat de statussen van HdnDossiers */
export interface DossierSamenvattingOutput {
    /** De gevonden HdnDossiers */
    readonly hdnDossiers: DossierSamenvatting[] | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat de versies van HdnDossiers voor een adviesdossier. */
export interface DossierVersieOutput {
    /** Lijst met de HdnDossiers voor een adviesdossier */
    readonly hdnDossierVersies: HdnDossierVersie[] | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Dossierstatus Geen = 0, InBehandeling = 1, Actief = 2, NietActief = 3 */
export enum Dossierstatus {
    Geen = "Geen",
    InBehandeling = "InBehandeling",
    Actief = "Actief",
    NietActief = "NietActief",
}

/** FinancieringOptions AankoopNieuwbouw = 1, AankoopBestaandeBouw = 2, HuidigeHypotheekWijzigen = 3, GeenFinanciering = 4 */
export enum FinancieringOptions {
    AankoopNieuwbouw = "AankoopNieuwbouw",
    AankoopBestaandeBouw = "AankoopBestaandeBouw",
    HuidigeHypotheekWijzigen = "HuidigeHypotheekWijzigen",
    GeenFinanciering = "GeenFinanciering",
}

/** GeslachtOpties Geen = 0, Man = 1, Vrouw = 2 */
export enum GeslachtOpties {
    Geen = "Geen",
    Man = "Man",
    Vrouw = "Vrouw",
}

export interface HdnBericht {
    hdnBerichtId: string;
    aanvraagVersie: number;
    berichtType: string;
    statusMelding: string | null;
    datum: string;
    status: HdnBerichtStatus;
    berichtVersie: string | null;
    aantalVerzendPogingen: number;
}

/** HdnBerichtStatus Aangeboden = 1, Verzonden = 2, Ontvangen = 3, TijdelijkeFout = 8, Fout = 9 */
export enum HdnBerichtStatus {
    Aangeboden = "Aangeboden",
    Verzonden = "Verzonden",
    Ontvangen = "Ontvangen",
    TijdelijkeFout = "TijdelijkeFout",
    Fout = "Fout",
}

/** HdnBerichtType AX = 0, LX = 1, OX = 2, SX = 3, VX = 4, DA = 5, DX = 6 */
export enum HdnBerichtType {
    AX = "AX",
    LX = "LX",
    OX = "OX",
    SX = "SX",
    VX = "VX",
    DA = "DA",
    DX = "DX",
}

export interface HdnBerichtVerzonden {
    datumVerzonden: string;
    aantalDagenVerwijderDrempel: number;
    verwijderDrempelOverschreden: boolean;
}

export interface HdnBinnengekomenDocument {
    datum: string;
    hdnDocumentId: string;
    omschrijving: string | null;
    documentSoort: string;
    bestandsNaam: string | null;
    status: HdnDocumentStatus;
}

/** HdnDocumentStatus Ontvangen = 1, Gevraagd = 2, Aangeboden = 3, Verzonden = 4, InBehandeling = 5, VoorlopigAkkoord = 6, Akkoord = 7, Vervallen = 8, Fout = 9, Afgekeurd = 10 */
export enum HdnDocumentStatus {
    Ontvangen = "Ontvangen",
    Gevraagd = "Gevraagd",
    Aangeboden = "Aangeboden",
    Verzonden = "Verzonden",
    InBehandeling = "InBehandeling",
    VoorlopigAkkoord = "VoorlopigAkkoord",
    Akkoord = "Akkoord",
    Vervallen = "Vervallen",
    Fout = "Fout",
    Afgekeurd = "Afgekeurd",
}

export interface HdnDossierAanvrager {
    hdnDossierAanvullingId: string;
    geboortedatum: string | null;
    postcode: string | null;
    woonplaats: string | null;
    achternaam: string | null;
    voorvoegsel: string | null;
    voorletters: string | null;
    voornamen: string | null;
}

/** HdnDossierStatus Loopt = 1, Afgerond = 2, Vervallen = 3 */
export enum HdnDossierStatus {
    Loopt = "Loopt",
    Afgerond = "Afgerond",
    Vervallen = "Vervallen",
}

export interface HdnDossierVersie {
    hdnDossierId: string;
    readonly analyseId: string | null;
    readonly dekkingId: string | null;
    aanvraagVersie: number;
}

export interface HdnGevraagdDocument {
    aanleverenVoorDatum: string | null;
    aanleverenVoorMoment: string | null;
    laatsteWijziging: string;
    kenmerk: string;
    mijNr: string;
    bronNr: string | null;
    opgevraagdViaBron: boolean;
    betreft: string | null;
    hdnDocumentId: string;
    omschrijving: string | null;
    documentSoort: string;
    bestandsNaam: string | null;
    status: HdnDocumentStatus;
}

/** Klantnaam en gegevens */
export interface KlantnaamReadOnly {
    klantId: string;
    readonly achternaam: string | null;
    readonly voorvoegsel: string | null;
    readonly voorletters: string | null;
    readonly voornamen: string | null;
    geslacht: GeslachtOpties | null;
    readonly roker: boolean | null;
    readonly geboortedatum: string | null;
    readonly aowdatum: string | null;
}

/** Bevat de gegevens van de laatst verzonden HDN-aanvraag van een adviesdossier. */
export interface LaatstVerzondenAanvraagOutput {
    laatstVerzondenAanvraag: HdnBerichtVerzonden | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** SoftwareKoppelingOptions Elements = 1, Finly = 2, Accellerate = 3, Anders = 99 */
export enum SoftwareKoppelingOptions {
    Elements = "Elements",
    Finly = "Finly",
    Accellerate = "Accellerate",
    Anders = "Anders",
}

export interface ValidationResultModel {
    code: string | null;
    target: string | null;
    message: string | null;
}

export interface ValidationResultsModel {
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface VersionInfo {
    naam: string | null;
    versie: string | null;
    auteur: string | null;
    copyright: string | null;
    opstartDatumTijd: string | null;
}

/** Model voor het zoeken van advies- en bemiddelingdossiers */
export interface ZoekHdnDossierInput {
    /** Input voor het zoeken op naam, achternaam en/of tussenvoegsel */
    zoekNaamInput: string | null;
    /** Specifieke hdn dossier-id waarop gezocht wordt */
    hdnDossierId: string | null;
    /** Specifieke vestiging waarop gezocht wordt óf alle vestigingen als deze null is */
    zoekVestigingId: string | null;
    /** Pagina nummer dat getoond moet worden */
    paginaNummer: number;
    /** Aantal zoekresultaten dat getoond moet worden per pagina */
    aantalResultatenPerPagina: number;
    /** Waarde voor het filteren op geboortedatum */
    geboorteDatum: string | null;
    /** Waarde voor het filteren op postcode */
    postcode: string | null;
    /** Waarde voor het filteren op woonplaats */
    woonplaats: string | null;
    soortAanvraag: HdnBerichtType;
    /** Als er enkel op de dossiers van de adviseur gezocht moet worden, dient deze gevuld te zijn */
    doorzoekAlleAdviezen: boolean;
    zoekResultaatSorteerOptions: ZoekResultaatSorteerOptions;
    /** Naamdelen van de zoekinput */
    readonly naamDelen: string[] | null;
}

/** ZoekResultaatSorteerOptions AchternaamOplopend = 0, AchternaamAflopend = 1, GeboorteDatumOplopend = 2, GeboorteDatumAflopend = 3, PostcodeOplopend = 4, PostcodeAflopend = 5, WoonplaatsOplopend = 6, WoonplaatsAflopend = 7 */
export enum ZoekResultaatSorteerOptions {
    AchternaamOplopend = "AchternaamOplopend",
    AchternaamAflopend = "AchternaamAflopend",
    GeboorteDatumOplopend = "GeboorteDatumOplopend",
    GeboorteDatumAflopend = "GeboorteDatumAflopend",
    PostcodeOplopend = "PostcodeOplopend",
    PostcodeAflopend = "PostcodeAflopend",
    WoonplaatsOplopend = "WoonplaatsOplopend",
    WoonplaatsAflopend = "WoonplaatsAflopend",
}

/** Een regel uit het resultaat van het zoeken naar adviesdossiers. */
export interface ZoekenAdviesdossier {
    /** Unieke identificatie van een gevonden adviesdossier. */
    adviesdossierId: string;
    /** Datum dat het adviesdossier voor het laatst bewerkt is. */
    readonly laatstBewerktDatum: string | null;
    /** Tijd dat het adviesdossier voor het laatst bewerkt is. */
    laatstBewerktTijd: string | null;
    aanleiding: FinancieringOptions | null;
    /** Korte omschrijving van het adviesdossier. */
    readonly omschrijving: string | null;
    status: Dossierstatus;
}

/** Een regel uit het resultaat van een zoekopdracht. */
export interface Zoekresultaat {
    /** De unieke identificatie van het klantdossier waar dit zoekresultaat onder valt. */
    klantdossierId: string;
    /** Het recentste moment dat een adviedossier van deze klant(en) geopend is. */
    readonly laatstGeopendDatum: string | null;
    /** Tijd dat het adviesdossier voor het laatst geopend is. */
    readonly laatstGeopendTijd: string | null;
    /** De gebruikersnaam van de persoon die het adviesdossier het laatst geopend heeft. */
    readonly laatstGeopendDoor: string | null;
    aanvrager1: KlantnaamReadOnly | null;
    aanvrager2: KlantnaamReadOnly | null;
    adviseur: ZoekresultaatAdviseur | null;
    /** De naam van de vestiging waar de klant staat ingeschreven. */
    readonly naamVestiging: string | null;
    /** Het guid van de vestiging waar de klant staat ingeschreven. */
    vestigingId: string;
    /** De postcode van het woonadres van aanvrager 1 */
    readonly postcode: string | null;
    /** De woonplaats van aanvrager 1 */
    readonly woonplaats: string | null;
    /** De adviesdossiers van deze klanten. */
    readonly adviesdossiers: ZoekenAdviesdossier[] | null;
    /** Aantal HDN  dossiers bij dit adviesdossier. */
    aantalHdnDossiers: number;
    /** De HDN dossiers voor deze klant. */
    readonly hdnDossiers: DossierSamenvatting[] | null;
}

/** Gegevens van de adviseur, benodigd om weer te geven in het zoekresultaat. */
export interface ZoekresultaatAdviseur {
    /** Unieke identificatie van de Adviseur */
    adviseurId: string;
    /** Achternaam */
    readonly achternaam: string | null;
    /** Voorvoegsel */
    readonly voorvoegsel: string | null;
    /** Voorletters */
    readonly voorletters: string | null;
    /** Roepnaam */
    readonly voornamen: string | null;
    geslacht: GeslachtOpties;
}

/** Het resultaat van een zoekopdracht. */
export interface ZoekresultaatDossierOutput {
    /** De gevonden resultaten. */
    readonly zoekresultaten: Zoekresultaat[] | null;
    /** Totaal aantal gevonden resultaten. */
    totalNumberOfResults: number;
    /** Totaal aantal gevonden resultaten. */
    totalNumberOfPages: number;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}